import { JSX, PropsWithChildren, useEffect, useState } from 'react';
import { useAuthContext } from '../contexts/auth.context';
import { useAppStore } from '../stores/app.store';
import { Footer } from './footer';
import { Header } from './header';
import { PageLoading } from './page-loading';

export function Layout({ children }: PropsWithChildren): JSX.Element {
  const { isUserLoading } = useAuthContext();

  const loading = useAppStore((state) => state.loading);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!isUserLoading) setIsLoading(false);
  }, [isUserLoading]);

  return (
    <div className="min-h-screen flex flex-col bg-base-200">
      {isLoading ? (
        <PageLoading />
      ) : (
        <>
          <Header />
          {loading && <PageLoading />}
          <main className={`width-limiter flex-grow-1 p-5 pt-0 sm:pt-5 flex flex-col ${loading && 'hidden'}`}>
            {children}
          </main>
          <Footer />
        </>
      )}
    </div>
  );
}
